import { List } from 'immutable'
import 'intersection-observer'
import * as React from 'react'
import { AsyncState, IOWidget, Link as LinkComponent, Updater, async, fromJSX } from 'widgets-for-react'
import { PublicSiteState } from '../../../../../../../root/state'
import { CMSState, Link } from '../../../../cms/blocks/types.gen'
import { link } from '../../../../cms/blocks/utils.gen'
import { PaginatedItem } from '../../../../drupal/types_and_parser/extra_types.mod'
import { ParsedNodeStory } from '../../../../drupal/types_and_parser/types.ext.gen'
import { loader } from '../../../templates/loader.mod'
import moment from 'moment'

export type PressReleaseItem = {
  title: string // "Project delivers robust Q2 2020 results",
  description: string // "<p><strong>Project delivers robust Q2 2020 results</strong></p>",
  published_at: string // "Thu, 13 Aug 2020 06:30 GMT",
  subject: string
  xml_link: string // "https://www.globenewswire.com/HexMLItem/Content/FullText/Attachments/All/Identifier/2077636/language/en",
  id: string // "2077636",
  category: string // "7125",
  text: null
}

export type pressReleasesBlockProps = {
  blockIndex: number
  item_limit?: number
  show_year_filter?: boolean
  button?: Link
  press_releases: AsyncState<PaginatedItem<PressReleaseItem>>
}

export type pressReleasesBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  footer_classname: string
  clickable_classname: string
  visual_classname: string
}>

export function pressReleasesBlock(
  props: pressReleasesBlockProps,
  options?: { style: pressReleasesBlockStyle; key?: string }
): (s: CMSState) => IOWidget<PublicSiteState, Updater<CMSState>> {
  return (s: CMSState) => (public_state: PublicSiteState) =>
    fromJSX((setState) => {
      return (
        <section className="block block--releases ls-block-spacing">
          <div className="block__inner ls-container">
            <header className="block__header">
              <h2 className="block__title title--l">Latest news</h2>
            </header>

            <div className="block__content">
              {async(props.press_releases).run((a) => {
                setState((s0) => {
                  // let block = s0.blocks.get(props.block_index) as storiesBlockData
                  let block = s0.blocks.get(props.blockIndex) as any
                  block.value[0].press_releases = a(block.value[0].press_releases) as AsyncState<
                    PaginatedItem<ParsedNodeStory>
                  >
                  return { ...s0, blocks: s0.blocks.set(props.blockIndex, block) }
                })
              })}
              {props.press_releases.kind == 'loaded' ? (
                <PressReleasesGrid
                  items={props.press_releases.value.items}
                  item_limit={props.item_limit}
                  show_year_filter={props.show_year_filter}
                />
              ) : (
                loader.run((_) => {})
              )}
            </div>
            {props.button && (
              <footer className="block__footer ls-container">
                {link(props.button, { classname: 'link' }, props.button.title)}
              </footer>
            )}
          </div>
        </section>
      )
    })
}

type PressReleasesGridProps = {
  items: Array<PressReleaseItem>
  item_limit?: number
  show_year_filter?: boolean
}
type PressReleasesGridState = {
  year: number
}

class PressReleasesGrid extends React.Component<PressReleasesGridProps, PressReleasesGridState> {
  years = [2020, 2019, 2018, 2017, 2016, 2015]

  constructor(props: PressReleasesGridProps) {
    super(props)

    this.state = {
      year: 2020
    }
  }

  render() {
    return (
      <>
        {this.props.show_year_filter && (
          <ul className="tabs">
            {this.years.map((year) => (
              <li className={`tabs__item tab title--s${this.state.year == year ? ' tab--active' : ''}`}>
                <button className={`tab__button`} onClick={(e) => this.setState({ year: year })}>
                  {year}
                </button>
              </li>
            ))}
          </ul>
        )}
        <ul className="block__list grid">
          {this.props.items
            .slice(0, this.props.item_limit ? this.props.item_limit : this.props.items.length)
            .filter((press_release) => moment(press_release.published_at).year() == this.state.year)
            .map((press_release) => {
              return (
                <li className="grid__item">
                  <article className="grid__article">
                    <LinkComponent className="grid__link" to={`/en/press-releases/${press_release.id}`}>
                      <div className="grid__content">
                        <header className="grid__header">
                          <span className="grid__label block__label tag--m">
                            {moment(press_release.published_at).format('D MMMM YYYY')}
                          </span>
                          <h3 className="grid__title title--s">{press_release.title}</h3>
                        </header>
                        <span className="grid__fauxlink link link--arrow">Read more</span>
                      </div>
                    </LinkComponent>
                  </article>
                </li>
              )
            })}
        </ul>
      </>
    )
  }
}
